import { create } from "zustand";
import {
	RealtimeSubscriptionSlice,
	createRealtimeSubscriptionStore,
} from "./realtime-subscriptions.store";
import { ReplySlice, createReplyStore } from "./reply.store";
import { MessageSlice, createMessageStore } from "./message.store";

interface RealtimeStore
	extends RealtimeSubscriptionSlice,
		ReplySlice,
		MessageSlice {}

export const useRealtimeStore = create<RealtimeStore>((...args) => ({
	...createRealtimeSubscriptionStore(...args),
	...createReplyStore(...args),
	...createMessageStore(...args),
}));
